var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Typography } from "@mui/material";
import { RequerimentoCustomRadioGroup } from "../../../../components/RequerimentoCustomRadioGroup";
import { useRequerimentoContext } from "../context/RequerimentoContext";
export var PossuiInventario = function () {
    var _a = useRequerimentoContext(), procuradorInventariante = _a.procuradorInventariante, setProcuradorInventariante = _a.setProcuradorInventariante, _requerimento = _a._requerimento;
    var requerimento = _requerimento[0], setRequerimento = _requerimento[1];
    var handleChange = function (event) {
        var value = event.target.value === "true";
        setRequerimento(__assign(__assign({}, requerimento), { requerimentoInventariante: undefined, requerentePf: undefined, requerentePj: undefined }));
        setProcuradorInventariante(value);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "h6", gutterBottom: true }, { children: "\u00C9 procurador de um inventariante?" })), _jsx(RequerimentoCustomRadioGroup, { value: procuradorInventariante, onChange: handleChange, defaultValue: "false", sx: { flexDirection: "column" }, options: [
                    { value: "true", label: "Sim" },
                    { value: "false", label: "Não" },
                ] })] }));
};
